var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignContracts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 115,
    viewBox: "0 0 168 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_signContracts)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M103.828 101.215l-14.585 5.604-21.319 8.182c-.804-1.483-1.99-3.512-3.46-5.92-5.048-8.309-13.402-21.233-20.838-32.59a3650.968 3650.968 0 00-15.593-23.603l5.221-1.503 42.65-12.283 27.924 62.113z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.12 100.205l-14.585 5.603-21.319 8.183c-.804-1.483-1.99-3.512-3.46-5.92-5.047-8.31-13.402-21.233-20.838-32.59a3618.219 3618.219 0 00-15.593-23.603l5.221-1.503 42.65-12.283 27.924 62.113z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M104.119 100.205l-14.585 5.603a110.468 110.468 0 01-24.778 2.263c-5.049-8.31-13.404-21.233-20.84-32.59L33.545 50.374l42.65-12.283 27.924 62.113z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.972 96.716s-22.66 13.31-56.489 10.307l-26.972-65.29 12.925-2.205 44.679-7.619 25.351 63.546.506 1.261z",
    fill: "#DADADA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M114.466 95.455c-5.336.26-11.507.235-17.718-.5-6.72-.783-13.473-2.403-19.275-5.368-4.845-2.48-8.987-5.172-12.6-8.405-9.395-8.392-15.21-20.396-20.431-41.654l44.68-7.619 25.344 63.546z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.085 91.805s-16.71 3.252-33.702 1.25c-6.72-.788-13.48-2.403-19.274-5.369-4.845-2.48-8.987-5.172-12.6-8.405-11.633-10.395-17.77-26.31-24.101-58.463 0 0 27.772 6.655 55.21-7.922 0 0 9.255 57.36 34.467 78.91z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M97.383 93.053c-6.72-.787-13.48-2.402-19.275-5.368-4.845-2.479-8.987-5.172-12.6-8.405 9.9-.798 11.323-6.174 11.323-6.174 7.34 11.569 20.552 19.947 20.552 19.947z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M55.77 32.624s14.918 1.69 28.881-6.1l.957 3.05S72.25 36.19 55.77 36.19v-3.565z",
    fill: "#F9D700"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M55.77 47.683s14.831-1.188 31.342-9.112l.558 1.268s-6.076 7.593-31.9 9.577v-1.733zm1.757 5.871s14.831-1.188 31.342-9.11l.558 1.267s-6.075 7.6-31.9 9.586v-1.743zm1.611 6.33s14.83-1.188 31.341-9.11l.559 1.267s-6.084 7.596-31.9 9.586v-1.743zm1.909 5.429s14.831-1.189 31.341-9.111l.559 1.268s-6.075 7.597-31.9 9.587v-1.744z",
    fill: "#BDD1F3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M62.805 71.194s14.83-1.189 31.341-9.111l.559 1.267s-6.077 7.598-31.9 9.586v-1.743z",
    fill: "#E8EEF8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M93.71 34.619l-4.15 1.403 1.412 4.12 4.15-1.402-1.412-4.121zm2.36 6.129l-4.15 1.403 1.412 4.121 4.15-1.403-1.413-4.12zm3.786 11.795l-4.15 1.403 1.413 4.12 4.15-1.402-1.413-4.121zm2.171 6.331l-4.15 1.403 1.413 4.12 4.15-1.402-1.413-4.121zm-4.031-11.76l-4.15 1.403 1.412 4.12 4.15-1.402-1.412-4.121z",
    fill: "#F9D700"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M125.658 77.704l-.23.025v.11s.521-.057 1.277-.135c1.276-.128 3.226-.309 4.516-.362-.893-.081-3.841.189-5.563.362z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.527 60.003l11.632-4.314a1.113 1.113 0 011.197.28 1.101 1.101 0 01.296.787 1.095 1.095 0 01-.719.99l-11.632 4.316-2.492-.248 1.718-1.81z",
    fill: "#5C5C8E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M115.228 55.986c.103.273.092.576-.03.84a1.106 1.106 0 01-.62.575l-11.632 4.314-1.873-.186-.269.289 2.492.248 11.633-4.316a1.104 1.104 0 00.719-.99 1.1 1.1 0 00-.522-.972c.04.063.075.129.102.198z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.527 60.004l.775 2.059-2.046-.204-.447-.044.612-.644 1.106-1.167z",
    fill: "#EFC8C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.418 61.17a.434.434 0 01.119.13c.019.03.03.065.03.1 0 .036-.011.07-.03.1a.454.454 0 01-.113.08.37.37 0 00-.166.279l-.448-.045.608-.644z",
    fill: "#727A9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.372 37.693l-1.961-.95a.238.238 0 01-.133-.226.235.235 0 01.024-.089l.208-.424a.234.234 0 01.227-.133c.031.002.062.01.09.024l1.322.64 1.38-2.81a.238.238 0 01.316-.11l.428.208a.235.235 0 01.133.226.234.234 0 01-.024.09l-1.693 3.445a.235.235 0 01-.227.132.237.237 0 01-.09-.023zm4.287 12.154l-1.962-.95a.237.237 0 01-.133-.225.233.233 0 01.024-.09l.208-.424a.238.238 0 01.318-.108l1.32.64 1.379-2.813a.238.238 0 01.317-.11l.426.208a.237.237 0 01.134.226.234.234 0 01-.023.089l-1.693 3.446a.24.24 0 01-.318.109l.002.002zm-1.927-5.989l-1.961-.95a.237.237 0 01-.11-.315l.209-.424a.235.235 0 01.317-.109l1.322.64 1.38-2.814a.234.234 0 01.135-.12.237.237 0 01.181.012l.428.206a.24.24 0 01.109.316l-1.694 3.45a.234.234 0 01-.136.119.237.237 0 01-.181-.011h.001zm3.786 11.475l-1.962-.95a.235.235 0 01-.109-.315l.208-.424a.235.235 0 01.228-.132c.03.002.061.01.09.023l1.321.64 1.38-2.81a.24.24 0 01.318-.11l.426.209a.229.229 0 01.121.134.235.235 0 01-.012.18l-1.69 3.447a.24.24 0 01-.32.108z",
    fill: "#3ACC6C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_signContracts"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h168v115H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignContracts);
export default __webpack_public_path__ + "static/media/signContracts.9e2be8bce003403fb0506325d995a30f.svg";
export { ForwardRef as ReactComponent };